import {Component, Inject, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Ttm} from '../../classes/ttm';
import {TtmTicketService} from '../../services/ttm-ticket.service';
import {TtmTicket} from '../../classes/ttm-ticket.class';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Project} from '../../classes/project';
import {TtmType} from '../../classes/ttmtype';
import {TtmStatus} from '../../classes/ttmstatus';
import {CodaltComponent} from '../codalt/codalt.component';
import {Workorder} from '../../classes/workorder';
import {ErrorStateMatcher} from '@angular/material/core';

@Component({
    selector: 'app-ttm-ticket-dialog',
    templateUrl: './ttm-ticket-dialog.component.html',
    styleUrl: './ttm-ticket-dialog.component.scss'
})
export class TtmTicketDialogComponent extends CodaltComponent implements OnInit {
    reportForm = new FormGroup({
        type: new FormControl('other', Validators.required),
        comment: new FormControl(''),
        ttm_id: new FormControl<number | null>(null),
        workorder_id: new FormControl<number | null>(null)
    });

    typeOptions = TtmTicketTypeOptions;

    // Only show the required error after the user typed, not when the empty field loses focus
    showErrorAfterInput: ErrorStateMatcher = {
        isErrorState: control => !!control?.invalid && !!control?.dirty
    };

    constructor(private matSnackBar: MatSnackBar,
                public dialogRef: MatDialogRef<TtmTicketDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: {
                    ttm?: Ttm,
                    workorder?: Workorder,
                    project: Project,
                    ttmTypes?: TtmType[],
                    ttmStatuses?: TtmStatus[]
                },
                private ttmTicketService: TtmTicketService) {
        super();
    }

    ngOnInit() {
        if (this.data.workorder) {
            // The problem types only apply to a TTM, so the comment is the only description of the problem
            this.reportForm.controls.workorder_id.setValue(this.data.workorder.id);
            this.reportForm.controls.comment.addValidators(Validators.required);
            this.reportForm.controls.comment.updateValueAndValidity();
        } else {
            this.reportForm.controls.ttm_id.setValue(this.data.ttm.id);
        }
    }

    onSubmit(): void {
        if (this.reportForm.valid) {
            this.ttmTicketService.saveTicket(this.reportForm.value as TtmTicket).subscribe(response => {
                const subject = this.data.workorder ? 'Werkopdracht' : 'TVM';
                this.matSnackBar.open(`${subject} is succesvol gemeld!`, null, {duration: 2000});
                this.dialogRef.close(response);
            });
        }
    }

    onClose(): void {
        this.dialogRef.close();
    }
}

export const TtmTicketTypeOptions = {
    incorrectLocation: 'Locatie is onjuist',
    incorrectImage: 'Afbeelding is onjuist',
    incorrectIcon: 'Raar teken in tekst (font/icoon probleem)',
    tooManyMeasures: 'Te veel maatregelen samengevoegd',
    tooFewMeasures: 'Te weinig maatregelen samengevoegd',
    incorrectType: 'Onjuist type',
    shouldNotBeDrawn: 'Had niet getekend moeten worden',
    incorrectDrawn: 'Onjuist getekend op kaart',
    other: 'Overig'
};

export const TtmTicketDepartmentOptions = {
    technical: 'Techniek (Codalt)',
    design: 'Ontwerp (Tekenaar)',
    projectcoordinator: 'Projectcoördinator',
    productowner: 'Product Owner'
}

export const TtmTicketStatusOptions = {
    new: 'Nieuw',
    in_progress: 'In behandeling',
    resolved: 'Afgehandeld',
};
